import { t } from '@lingui/macro';

import {
  GlobalAnnouncements,
  PaginatedGlobalAnnouncementsList,
} from '@rover/rsdk/src/apiClient/latest';

export default function fetchGlobalAnnouncementsResponseFactory(
  opts?: Partial<PaginatedGlobalAnnouncementsList>
): PaginatedGlobalAnnouncementsList {
  return {
    count: 0,
    results: [],
    ...opts,
  };
}

const translatedGdprBannerText = (): string =>
  t`Our website uses cookies. By continuing to use our site, you agree to our use of cookies. To see what cookies we serve and set your own preferences, please review our Cookie Policy.`;

// Edge Cached pages cannot contain user specific announcements, but the
// EU Cookie Consent GDPR banner is dismissable (cookied) and EU specific
// Quick fix is to always-show the banner by hardcoding it here.
// We'll implement a long term solution in DEV-60859.
export function hardcodedEdgeCacheableGlobalAnnouncements(): Array<
  GlobalAnnouncements & { edgeId: string }
> {
  return [
    {
      contentClass: '',
      action: null,
      text: '',
      iconKey: '',
      isDismissible: true,
      isDismissed: false,
      isDismissedCookie: 'gdx-8c071970',
      webAction: '/terms/cookies/',
      html: translatedGdprBannerText(),
      actionText: t`Learn More`,
      event: '',
      slug: 'cookie-policy',
      textHeadline: '',
      textDescription: translatedGdprBannerText(),
      url: '/api/v4/announcements/global/cookie-policy/',
      edgeId: 'city-landing-gdpr-banner',
    },
  ];
}
